export const userStatus = {
  NOT_INVITE: 'NOT_INVITE',
  INVITE: 'INVITE',
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  DEACTIVE: 'DEACTIVE'
};

export const inviteStatus = {
  INVITED: 'INVITED',
  EXPIRED: 'EXPIRED',
  ACCEPTED: 'ACCEPTED'
};

export const shiftType = [
  {
    id: "1",
    name: "Ca thường",
  },
  {
    id: "2",
    name: "Ca gãy",
  },
];

export const payType = [
  {
    id: "PAY_BY_DAY",
    name: "Tính theo công",
  },
  {
    id: "PAY_BY_HOUR",
    name: "Tính theo giờ",
  },
]

export const genderList = [
  {id: "MALE", name: "Nam"},
  {id: "FEMALE", name: "Nữ"},
  {id: "OTHER", name: "Khác"},
];

export const channelPrice = [
  {id: "ALL", name: "Tất cả"},
  {id: "AGENCY", name: "Đại lý"},
  {id: "SALESMAN", name: "Salesman"},
  {id: "IPOS", name: "iPOS"},
  {id: "TELESALES", name: "Telesales"},
];

export const listUserGroup = [
  {id: 'CUSTOMER', name: 'Khách hàng'},
  {id: 'SHIPPER', name: 'Từ giao hàng'},
  {id: 'AGENCY', name: 'Từ đại lý'},
  {id: 'SALESMAN', name: 'Từ salesman'},
]

export const listCurrency = [{id: 'VND', name: 'VND'},{id: 'USD', name: 'USD'}]

export const listPromotionApplyType = [
  {id: 'AFTER_DISCOUNT', name: 'Sau giảm giá hàng hoá'},
  {id: 'BEFORE_DISCOUNT', name: 'Trước giảm giá hàng hoá'},
]

export const listTypePrice = [
  {id: 'EXPORT', name: 'Giá bán'},
  {id: 'IMPORT', name: 'Giá nhập'}
]

export const listVatType = [
  {id: 'NORMAL', name: 'VAT xuôi'},
  {id: 'REVERSE', name: 'VAT ngược'}
]
